import {createContext} from "@acng/frontend-relativity";
import {Session} from "../model/game.js";

/**
 * @type {import("@acng/frontend-relativity").Context<?Session>}
 */
export const ctxGame = createContext();
